import React from 'react';
import { TYPE } from '../../constant';
import useHackleInfo from '../../hooks/useHackle';
import Button from './Button';

const HackleLearningDelBtn = (props) => {
    const { info : hackleInfo  } = useHackleInfo();
    const getHackle = hackleInfo?.INIT_ONBOARDING;

    // test
    // props.hackleInfo.globalInfo.language = "en";
    // props.hackleInfo.globalInfo.variation = "A"; 
    // props.hackleInfo.globalInfo.deviceType = TYPE.DEVICE.PHONE;

    const coditionC = (getHackle?.language === 'en' && getHackle?.variation === "C" && getHackle?.deviceType === TYPE.DEVICE.PHONE);
    
    return (
        <>
            { !coditionC && <Button onClick={props.onClick} className="btn-learning-del on">삭제</Button> }
            { coditionC && 
                <Button className="btn_ab_test" onClick={props.onClick} style={{
                    zIndex: '25'
                }}>
                    <span className="reset">Reset</span>
                    <span>Notepad</span>
                </Button>
            }
        </>
        
    );
};

export default HackleLearningDelBtn;